<template>
  <v-select
    v-model="item"
    dir="rtl"
    :clearable="clearable"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    @open="onOpen"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

export default {
  name: 'ZOrder',
  props: {
    value: {
      type: Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    invoiceId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      items: [],
      val: this.value,
      loading: false,
    }
  },
  computed: {
    item: {
      get() {
        if (this.value) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  methods: {
    get() {
      if (this.items.length === 0) {
        this.loading = true
        this.$http.post(
          this.$api.order.getall, { InvoiceId: this.invoiceId },
        )
          .then(res => {
            this.items = res.data

            this.items.forEach(item => {
              item.Title = `${item.Id} . ${item.Patient} . ${item.OrderTooth.length} واحد`
            })

            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
    forceMenuOpen() {
      this.$nextTick(() => {
        if (this.$refs.mySelect) {
          this.$refs.mySelect.isMenuActive = true // باز نگه داشتن منو
        }
      })
    },
  },
}
</script>
